import React, { ComponentProps, createContext, useCallback, useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Column } from "../../DataTable";
import { Account } from "../types";
import { useClubSlug } from "../../Clubs/hooks";
import AsyncFormInput from "@form/AsyncFormInput";
import { FormInput } from "@form/index";

// The Mandant a document books into. Without one the backend picks the club's first Mandant,
// the same one an incoming document is booked against.
const AccountMandantContext = createContext<number | null | undefined>(undefined);

export const AccountMandantProvider = AccountMandantContext.Provider;

interface Props extends ComponentProps<typeof FormInput> {
    name: string;
    label?: string;
    clubSlug?: string | null;
    mandantId?: number | null;
}

const AccountFormInput = ({ name, label, clubSlug: clubSlugProp, mandantId: mandantIdProp, ...props }: Props) => {
    const { t } = useTranslation("invoice");
    const clubSlug = useClubSlug(clubSlugProp ?? undefined);
    const contextMandantId = useContext(AccountMandantContext);
    const mandantId = mandantIdProp ?? contextMandantId;
    const columns: Column<Account>[] = useMemo(() => [
        { uid: "number", name: t('account.columns.number') },
        { uid: "name", name: t('account.columns.name') }
    ], [t]);

    const keyResolver = useCallback((item: Account) => item.number, []);

    // Stays on the paginated list on purpose: the picker searches server-side as you type.
    return <AsyncFormInput name={name} label={label} keyResolver={keyResolver} tableColumns={columns}
        fetchUrl={`invoice/${clubSlug}/account${mandantId ? `?mandant_id=${mandantId}` : ""}`}
        stateKey={`invoice-account-input-${mandantId ?? "default"}`} inputProps={props}
    />;
};


export default AccountFormInput;
